var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.59998 19.23999c-.65998 1.65997-1.69996 3.29999-3.08997 4.88001-.44.5-.5 1.21997-.14001 1.77997.28003.44.73999.67999 1.23999.67999.14001 0 .28003-.00995.42004-.06 2.93994-.85999 9.81-3.90997 10-13.69.06995-3.76996-2.69-7.00995-6.28003-7.37995-1.98999-.20001-3.96997.44995-5.44 1.76996-1.46997 1.33002-2.31 3.23004-2.31 5.21002 0 3.29999 2.34003 6.19001 5.59998 6.81z",
    fill: "var(--current_svg_color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.71002 5.45001c-1.98004-.20001-3.96002.44995-5.42999 1.76996-1.47003 1.33002-2.31006 3.23004-2.31006 5.21002 0 3.29999 2.34003 6.19 5.60004 6.81-.66003 1.65997-1.70001 3.29999-3.09003 4.88-.44.5-.5 1.21997-.13995 1.77997.27997.44.73999.67999 1.23999.67999.13995 0 .27997-.00995.41998-.06 2.94-.85999 9.81-3.90997 10-13.69v-.13995c0-3.71002-2.72998-6.86999-6.28998-7.23999z",
    fill: "var(--current_svg_color)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.7baa3d8e531b38c6e0e813921d20e51c.svg";
export { ForwardRef as ReactComponent };